import { useUserForm } from "../../../Hook/Users/useUserForm";

import { Modal } from "react-bootstrap";
import Form from "../../../Components/Form/form";
import { useTranslation } from "react-i18next";
import { Person, Key } from "react-bootstrap-icons";

export default function UserForm({
    show,
    profiles,
    handleClose,
    user,
    idClient,
}) {
    const { t } = useTranslation(); // Hooks for translation
    const { isEditing, userForm, setUserForm, handleFormSubmit, handleCancel } =
        useUserForm({ idClient, user, onClose: handleClose }); // Custom hook to manage user form state

    const formConfig = {
        isEditing,
        submitText: isEditing
            ? t("common.actions.update")
            : t("common.actions.save"),
        sections: [
            {
                title: t("users.form.sections.basic-info"),
                icon: Person,
                columns: 1,
                fields: [
                    {
                        name: "name",
                        label: t("users.form.field.name.label"),
                        type: "text",
                        placeholder: t("users.form.field.name.placeholder"),
                        required: true,
                        errorMessages: {
                            required: t(
                                "users.form.field.name.errors.required"
                            ),
                        },
                    },
                    {
                        name: "email",
                        label: t("users.form.field.email.label"),
                        type: "email",
                        placeholder: t("users.form.field.email.placeholder"),
                        required: true,
                        errorMessages: {
                            required: t(
                                "users.form.field.email.errors.required"
                            ),
                        },
                    },
                    {
                        name: "id_profile",
                        label: t("users.form.field.profile.label"),
                        type: "select",
                        options: [
                            {
                                value: "",
                                label: t(
                                    "users.form.field.profile.placeholder"
                                ),
                            },
                            ...profiles.map((profile) => ({
                                value: profile.id,
                                label: profile.description,
                            })),
                        ],
                    },
                ],
            },
            {
                title: isEditing
                    ? t("users.form.sections.password-optional")
                    : t("users.form.sections.password"),
                icon: Key,
                columns: 2,
                fields: [
                    {
                        name: "password",
                        label: t("users.form.field.password.label"),
                        type: "password",
                        placeholder: t("users.form.field.password.placeholder"),
                        required: !isEditing,
                        autocomplete: false,
                        errorMessages: {
                            required: t(
                                "users.form.field.password.errors.required"
                            ),
                            minLength: t(
                                "users.form.field.password.errors.minLength"
                            ),
                            maxLength: t(
                                "users.form.field.password.errors.maxLength"
                            ),
                        },
                        minLength: 6,
                        maxLength: 100,
                    },
                    {
                        name: "confirm_password",
                        label: t("users.form.field.confirm-password.label"),
                        type: "password",
                        placeholder: t(
                            "users.form.field.confirm-password.placeholder"
                        ),
                        required: !isEditing,
                        autocomplete: false,
                        validate: (value) => {
                            if (isEditing && (!value || value.length === 0)) {
                                return null; // Não validar se estiver editando e o campo estiver vazio
                            }
                            if (userForm && value !== userForm.password) {
                                return t(
                                    "users.form.field.confirm-password.errors.match"
                                );
                            }
                            return null;
                        },
                        errorMessages: {
                            required: t(
                                "users.form.field.confirm-password.errors.required"
                            ),
                            minLength: t(
                                "users.form.field.confirm-password.errors.minLength"
                            ),
                            maxLength: t(
                                "users.form.field.confirm-password.errors.maxLength"
                            ),
                        },
                        minLength: 6,
                        maxLength: 100,
                    },
                ],
            },
        ],
        onSubmit: async () => {
            handleFormSubmit();
        },
        onCancel: () => handleCancel(),
        onChange: (newFormData) => {
            setUserForm(newFormData);
        },
        data: userForm,
    };

    return (
        <>
            <Modal
                show={show}
                size="lg"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                aria-labelledby="example-modal-sizes-title-lg"
                className="modal-create-user"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isEditing
                            ? t("users.form.header.title.edit")
                            : t("users.form.header.title.new")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form {...formConfig} />
                </Modal.Body>
            </Modal>
        </>
    );
}
